import type { ExperienceAggregations } from '@/shared/api/experience';
import type { TMovementType } from '@/entities/movement-type';
import { isValidMovementType } from '@/entities/movement-type';
import type { IExperienceAggregations } from './types.ts';

export const createExperienceAggregationsFromResource = (
  data: ExperienceAggregations | null,
): IExperienceAggregations | null => {
  if (!data) {
    return null;
  }

  const movementType = data.movement_type
    ? Object.entries(data.movement_type).reduce(
        (acc, [key, value]) => {
          if (isValidMovementType(key)) {
            acc[key] = value;
          }

          return acc;
        },
        {} as Record<TMovementType, number>,
      )
    : null;

  return {
    tags: data.tags || null,
    tagsSet: data.tags_set || null,
    type: data.type
      ? {
          private: data.type.private ?? null,
          group: data.type.group ?? null,
          tour: data.type.tour ?? null,
          ticket: data.type.ticket ?? null,
        }
      : null,
    customType: {
      minigroup: data.custom_type?.minigroup
        ? {
            total: data.custom_type.minigroup.total ?? null,
            type: {
              group: data.custom_type.minigroup.type?.group ?? null,
            },
          }
        : null,
    },
    movementType,
    price: data.price
      ? {
          personsCount: data.price.persons_count ?? null,
          histogramInterval: data.price.histogram_interval ?? null,
          histogram: data.price.histogram || null,
          defaultHistogram: data.price.defaultHistogram || data.price.histogram || null,
          range: data.price.range || null,
          defaultRange: data.price.defaultRange || data.price.range || null,
        }
      : null,
    duration: data.duration || null,
    date:
      Array.isArray(data.date) && data.date.length === 2
        ? [new Date(data.date[0] as Date).toISOString(), new Date(data.date[1] as Date).toISOString()]
        : [new Date().toISOString(), new Date().toISOString()],
    availability: data.availability || null,
  };
};
